module.exports = __webpack_public_path__ + "static/media/contactMail.e77867c7.png";